import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { createSurvey } from 'services/surveys';
import { getAllActive } from 'services/sites';

const AddSurvey = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    site_id: '',
    show_description: false
  });
  const [errors, setErrors] = useState({});
  const [sites, setSites] = useState([]);

  useEffect(() => {
    getAllActive()
      .then(response => {
        if (response && Array.isArray(response)) {
          setSites(response);
        } else {
          setSites([]);
        }
      })
      .catch(() => setSites([]));
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'El nombre es requerido.';
    if (!formData.site_id) newErrors.site_id = 'El sitio es requerido.';
    return newErrors;
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Por favor, completa todos los campos requeridos.', {
        theme: 'colored'
      });
      return;
    }

    // Prepara los datos para enviar, convirtiendo descripción vacía a null
    const dataToSend = {
      ...formData,
      description: formData.description.trim() || null
    };

    createSurvey(dataToSend)
      .then(response => {
        localStorage.setItem('selectedSurveyId', 0);
        if (response.result) {
          toast.success(`Encuesta "${formData.name}" creada exitosamente`, {
            theme: 'colored'
          });
          localStorage.setItem('selectedSurveyId', response.id);
          navigate('/surveys/edit');
        } else {
          toast.error('Ocurrió un error al crear la encuesta.', {
            theme: 'colored'
          });
        }
      })
      .catch(error => {
        console.error('Error al crear la encuesta:', error);
        toast.error('Ocurrió un error al crear la encuesta.', {
          theme: 'colored'
        });
      });
  };

  return (
    <Card>
      <Card.Header>
        <h5>Agregar Encuesta</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ingresa el nombre de la encuesta"
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Ingresa una descripción para la encuesta (opcional)"
              rows={4}
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="show_description"
              name="show_description"
              checked={formData.show_description}
              onChange={handleChange}
              label="Mostrar esta descripción en la encuesta"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Sitio</Form.Label>
            <Form.Select
              name="site_id"
              value={formData.site_id}
              onChange={handleChange}
              isInvalid={!!errors.site_id}
            >
              <option value="">Selecciona un sitio</option>
              {sites.map(site => (
                <option key={site.id} value={site.id}>
                  {site.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.site_id}
            </Form.Control.Feedback>
          </Form.Group>
          <Button variant="primary" type="submit">
            Crear Encuesta
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddSurvey;
